<template>
  <div class="wrap">
    <div class="nav p_f" :class="{'bgColor1' : scrollDistance >= domDistance }">
      <div class="nav-in con flex">
        <div class="left flex">
          <img src="../assets/image/logo.png" class="logo">
          <div class="logo-txt">行稳致远 创新共赢</div>
        </div>
        <ul class="right flex nav-in-right">
          <li :class="{'nav-cur' : navCur == '0' && scrollDistance < domDistance}" @click="scrollInto('viewTop')">首页</li>
          <li :class="{'nav-cur' : navCur == '1' && scrollDistance >= domDistance}" @click="scrollInto('viewBox')">关于我们</li>
        </ul>
      </div>
    </div>
    <div class="banner" ref="viewTop">
      <div class="swiperBanner swiper-container swiper-no-swiping">
        <div class="swiper-wrapper">
            <div class="swiper-slide p_r flex">
              <div class="banner-text p_r">
                <h1 class="fw7">微消之力 博大天地</h1>
                <p class="fs36 lh42 tac fw6">撬动生活的无限可能</p>
              </div>
              <img class="banner-img p_a" src="../assets/image/banner-1.jpg" alt="">
            </div>
            <div class="swiper-slide p_r flex">
              <div class="banner-text p_r">
                <h1 class="fw7">服务实体 助力小微</h1>
                <p class="fs36 lh42 tac fw6">让天下没有难做的生意</p>
              </div>
              <img class="banner-img p_a" src="../assets/image/banner-2.jpg" alt="">
            </div>
            <div class="swiper-slide p_r flex">
              <div class="banner-text p_r">
                <h1 class="fw7">风控为锚 科技为核</h1>
                <p class="fs36 lh42 tac fw6">科技驱动融资担保业务可持续发展</p>
              </div>
              <img class="banner-img p_a" src="../assets/image/banner-3.jpg" alt="">
            </div>
        </div>
        <div class="swiper-pagination banner-page"></div>
      </div>
    </div>
    <div class="module" ref="viewBox">
      <div class="module-in">
        <h1 class="tittle-txt tac fs36">公司简介</h1>
        <ul class="module-main flex con">
          <li class="main-l flex">
            <div>
              <h5 class="fs32 fw7">黑龙江省联丰融资担保有限公司</h5>
              <p class="fs20 lh30">成立于2018年，注册资本10.5亿元，主要开展消费金融、普惠金融、传统担保业务、绿色金融以及产业金融业务。经过6年的发展，公司与20多家银行、金融机构开展担保业务合作。</p>
            </div>
            <div>
              <h5 class="fs32 fw7">国资控股</h5>
              <p class="fs20 lh30">国有独资企业控股，背靠国务院国有资产监督管理委员会商业发展中心 ，管理规范，行稳致远 。</p>
            </div>
          </li>
          <img src="../assets/image/brief.jpg" class="main-img">
        </ul>
      </div>
    </div>
    <div class="module-box">
      <ul class="module-box-in flex con">
        <li class="flex box-in-li">
          <span>AA+</span>
          <p class="fs24 lh28">信用<br/>评级</p>
        </li>
        <li class="flex box-in-li">
          <span>10.5亿</span>
          <p class="fs24 lh28">实缴<br/>资本</p>
        </li>
        <li class="flex box-in-li">
          <span>20+</span>
          <p class="fs24 lh28">合作<br/>机构</p>
        </li>
      </ul>
    </div>
    <div class="module introduce" style="padding-top: 120px;">
      <div class="module-in">
        <h1 class="tittle-txt tac fs36">三大主营业务，打造科技融担企业</h1>
        <div class="module-main flex con">
          <div class="main-l flex" :class="`cur${tabIndex}`">
            <div class="main-l-in flex p_r" @click="tabIndex = 1">
              <img src="../assets/image/icon-1.png" class="icon" v-if="tabIndex != 1">
              <img src="../assets/image/icon-1-check.png" class="icon" v-else>
              <p class="fs24 lh28">消费金融</p>
            </div>
            <div class="main-l-in flex p_r" @click="tabIndex = 2">
              <img src="../assets/image/icon-2.png" class="icon" v-if="tabIndex != 2">
              <img src="../assets/image/icon-2-check.png" class="icon" v-else>
              <p class="fs24 lh28">普惠金融</p>
            </div>
            <div class="main-l-in flex p_r" @click="tabIndex = 3">
              <img src="../assets/image/icon-3.png" class="icon" v-if="tabIndex != 3">
              <img src="../assets/image/icon-3-check.png" class="icon" v-else>
              <p class="fs24 lh28">金融科技</p>
            </div>
          </div>
          <div class="main-img p_r">
            <div class="p_a mod" :class="{'show-box' : tabIndex == '1'}">
              <div class="main-img-txt p_r">
                <div class="txt p_a">
                  <div class="tab-tit fs32 lh38">消费金融</div>
                  <p class="tab-desc fs20 lh24">公司现有消金余额超10亿，合作平台超20家， 未来持续对消金产品进行<br/>创新，以满足居民多样化消费需求，促进消费金融的健康稳定发展.</p>
                </div>
                <img src="../assets/image/tab-1.jpg" class="p_a imgs">
              </div>
            </div>
            <div class="p_a mod" :class="{'show-box' : tabIndex == '2'}">
              <div class="main-img-txt p_r">
                <div class="txt p_a">
                  <div class="tab-tit fs32 lh38">普惠金融</div>
                  <p class="tab-desc fs20 lh24">公司致力服务小微企业， 为小微企业提供专业融资担保咨询服务，进一步<br/>解决企业融资难，融资贵问题。</p>
                </div>
                <img src="../assets/image/tab-2.jpg" class="p_a imgs">
              </div>
            </div>
            <div class="p_a mod" :class="{'show-box' : tabIndex == '3'}">
              <div class="main-img-txt p_r">
                <div class="txt p_a">
                  <div class="tab-tit fs32 lh38">金融科技</div>
                  <p class="tab-desc fs20 lh24">公司坚持科技创新，以科技驱动担保业务可持续发展，自研担保业务系<br/>统、信贷业务系统、风控决策引擎、贷后处置平台等 。</p>
                </div>
                <img src="../assets/image/tab-3.jpg" class="p_a imgs">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="module product">
      <div class="module-in">
        <h1 class="tittle-txt tac fs36">金融科技产品</h1>
        <ul class="flex con">
          <li class="main-l p_r" @click.stop="showPro = index" v-for="(item,index) in productList" :key="index">
            <div class="main-l-in flex p_r">
              <h5 class="fs24 lh28">{{ item.tit }}</h5>
              <span class="fs18 lh22">查看简介</span>
            </div>
            
            <div class="show-desc p_a ">
              <div class="p_r pop-p">
                <div 
                  @click.stop="hidePop"
                  class="show-desc-in p_a fs20 lh28"
                  :class="{'showPop':showPro == index}"
                >{{ item.desc }}</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer">
      <div class="tac fs12">地址：黑龙江省绥化市北林区苹果乐园小区12号楼9号商服</div>
      <div class="tac fs12">Copyright Ⓒ2024 黑龙江省联丰融资担保有限公司版权所有 ICP备案:黑ICP备2024025302号</div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'

export default {
  name: 'home',
  components: {
  },
  data () {
    return {
      navCur: 0,
      tabIndex: 1,
      domDistance: '',
      scrollDistance: '',
      showPro: null,
      productList: [
        {
          tit: '担保业务系统',
          desc: '服务于互联网化的担保业务，具备全面的担保业务支持体系，独立的三方账务核对平台，保证高效运营的同时，提升了业务的安全和灵活性 。'
        },
        {
          tit: '信贷业务系统',
          desc: '服务于互联网信贷业务的管理平台，提供多种专业产品化模块和丰富的组件配置，满足公司的日常业务需求 。'
        },
        {
          tit: '风控决策引擎',
          desc: '基于千亿数据沉淀而搭建完善的风控引擎，支持多种决策组件灵活配置，提供多维可视化界面展示，并兼具良好的系统拓展性 。'
        },
        {
          tit: '贷后处置系统',
          desc: '全方位、全流程的金融借贷案件处置平台，为持牌金融机构提供信贷不良资产处置的综合解决方案。'
        }
      ]
    }
  },
  created(){
    
  },
  mounted(){
    this.$nextTick( () => {
      this.swiperFun()
      window.addEventListener('scroll', this.handleScroll);

      const rect = this.$refs.viewBox.getBoundingClientRect();
      this.domDistance = rect.top + window.scrollY;
    })
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  },
  methods: {
    swiperFun(){
      var mySwiper = new Swiper('.swiper-container', {
        autoplay: 5000,
        effect : 'fade',
        pagination : '.swiper-pagination',
        paginationClickable :true,
        autoplayDisableOnInteraction : false,  //用户操作后，可继续自动轮播
      });
    },
    handleScroll() {
      this.scrollDistance = window.scrollY

      if( window.scrollY >= this.domDistance ) {
        this.navCur = 1
      } else {
        this.navCur = 0
      }
    },
    scrollInto(dom){
      this.$refs[dom].scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    },
    hidePop(){
      this.showPro = null
    }
  }

}
</script>

<style lang="less">
.wrap {
  .nav {
    width: 100%;
    height: 80px;
    min-width: 1200px;
    background: rgba(255,255,255,0.5);
    top: 0;
    z-index: 99;

    .nav-in {
      height: 100%;
      align-items: center;
      justify-content: space-between;

      .left {
        align-items: center;

        .logo {
          width: 230px;
          height: 48px;
        }

        .logo-txt {
          padding-left: 48px;
        }
      }

      .nav-in-right {

        li {
          margin-left: 52px;
          position: relative;
          cursor: pointer;

          &::before {
            content: "";
            width: 100%;
            height: 6px;
            display: none;
            position: absolute;
            bottom: -32px;
            background-color: #B22E04;
          }
          &:hover {
            color: #B22E04;
            font-weight: 700;

            // &::before {
            //   display: block;
            // }
          }

          &:first-child {
            margin-left: 0;
          }
        }

        .nav-cur {
          color: #B22E04;
            font-weight: 700;
          &::before {
            display: block;
          }
        }
      }
    }
  }

  .bgColor1 {
    background-color: #fff;
  }
  .banner {
    width: 100%;
    height: 750px;
    min-width: 1200px;

    .swiperBanner {
      width: 100%;
      height: 100%;

      .swiper-slide {
        align-items: center;
        justify-content: center;

        .banner-img {
          width: 100%;
          height: 100%;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
        }

        .banner-text {
          z-index: 2;
          color: #fff;
          text-shadow: 0px 2px 8px rgba(0, 0, 0, 0.4);

          h1 {
            font-size: 80px;
            line-height: 94px;
            padding-bottom: 8px;
          }
        }

        &:nth-child(2) {
          background-color: #567bc4;
        }

        &:nth-child(2) {
          background-color: #60b76f;
        }
      }
    }
  }

  .module {
    min-width: 1200px;
    padding: 100px 0 160px;
    background: linear-gradient( 180deg, #F1F5F9 0%, #FCFEFF 100%);

    .module-in {
      .tittle-txt {
        line-height: 42px;
      }

      .module-main {
        justify-content: space-between;
        padding-top: 60px;
        .main-l {
          flex: 1;
          flex-direction:column;
          justify-content: space-between;
          padding-right: 60px;

          h5 {
            color: #C22E00;
            line-height: 38px;
            padding-bottom: 16px;
          }

          p {
            color: #000;
          }
        }

        .main-img {
          width: 462px;
          height: 322px;
        }
      }
    }
    
  }

  .module-box {
    min-width: 1200px;
    height: 320px;
    background: url("../assets/image/bg.jpg") no-repeat center;
    background-size: 100% 100%;

    .module-box-in {
      height: 100%;
      align-items: center;
      justify-content: space-between;
      padding: 0 107px;

      .box-in-li {
        align-items: center;
        
        span {
          font-size: 64px;
          line-height: 75px;
          font-weight: 700;
          color: #C22E00;
        }

        p {
          padding-left: 8px;
        }
      }
    }
  }

  .introduce {
    background: linear-gradient( 180deg, #F1F5F9 0%, #FCFEFF 100%);

    .module-in {
      .module-main {
        .main-l {
          width: 100%;
          flex-direction: column; 
          background: #DDDFE1;
          margin-right: 20px;
          padding: 0; 

          .main-l-in {
            height: 33.33333%;
            flex-direction: column; 
            justify-content: center;
            align-items: center;
            cursor: pointer;

            &::before {
              content: "";
              width: 88%;
              height: 2px;
              display: block;
              background: linear-gradient( 90deg, rgba(194, 46, 0, .1) 0%, rgba(194, 46, 0, .6) 40%,rgba(194, 46, 0, .6) 60%,rgba(194, 46, 0, .1) 100%);
              position: absolute;
              bottom: 0;
            }

            &:last-child {
              &::before {
                display: none;
              }
            }

            .icon {
              width: 48px;
              height: 48px;
              display: inline-block;
            }

            p {
              color: #333;
              padding-top: 10px;
            }
          }
        }

        .cur1 {
          .main-l-in {
            &:nth-child(1){
              background-color: #C22E00;

              p {
                color: #fff;
              }

              &::before {
                display: none;
              }
            }
          }
        }
        .cur2 {
          .main-l-in {
            &:nth-child(2){
              background-color: #C22E00;

              p {
                color: #fff;
              }

              &::before {
                display: none;
              }
            }
          }
        }
        .cur3 {
          .main-l-in {
            &:nth-child(3){
              background-color: #C22E00;

              p {
                color: #fff;
              }

              &::before {
                display: none;
              }
            }
          }
        }
        .main-img {
          width: 894px;
          height: 558px;

          .mod {
            width: 100%;
            height: 100%;
            opacity: 0;
            z-index: 0;
            transition: opacity .5s ease-in;
          }

          .main-img-txt {
            height: 100%;
            
            .txt {
              padding: 56px 40px;
              z-index: 2;

              .tab-tit {
                text-shadow: 0px 2px 4px rgba(0,0,0,0.25);
                color: #fff;
              }

              .tab-desc {
                color: #fff;
                text-shadow: 0px 2px 4px rgba(0,0,0,0.25);
                padding-top: 10px;
              }
            }
            .imgs {
              z-index: 1;
            }
          }

          .show-box {
            opacity: 1;
            z-index: 1;
          }
        }
      }
    }
  }

  .product {
    background: url("../assets/image/product.jpg") no-repeat center;
    background-size: 100% 100%;
    ul {
      padding-top: 60px;
      justify-content: space-between;
      .main-l {
        padding: 40px 0 0;
        cursor: pointer;

        &:hover {
          .main-l-in {
            box-shadow: 0px 2px 15px 0px rgba(0,0,0,0.1);

            span {
              color: #C22E00;
            }
          }
          
        }

        .main-l-in {
          width: 280px;
          height: 180px;
          flex-direction: column; 
          background-color: #fff;
          padding: 24px;
          justify-content: space-between;

          span {
            color: #666;
          }

          
        }

        .show-desc {
          width: 280px;
          height: 220px;
          top: 0;
          color: #fff;
          overflow: hidden;
          z-index: 2;


          .pop-p {
            height: 100%;
          }

          .show-desc-in {
            height: 100%;
            top: 100%;
            padding: 24px;
            background: url("../assets/image/pop-bg.jpg") no-repeat;
            background-size: 100% 100%;
            transition: top .5s ease;
          }

          .showPop {
            top: 0
          }
        }
        .showPopZindex {
          z-index: 3;
        }
        
      }
    }
  }

  .footer {
    min-width: 1200px;
    color: #748EA6;
    background-color: #050F19;
    padding: 24px 0;

    div {
      &:first-child {
        padding-bottom: 12px;
      }
    }
  }
}
</style>
